import { useState, useEffect, useCallback, useContext } from "react";
import { apiRoutes } from "../utils/apiRoutes";
import { fetchData } from "../utils/methods";
import { validateString } from "../utils/validateString";
import { useAlert } from "../utils/AlertContext";
import { TranslationsContext } from "../utils/TranslationsContext";

const defaultEvent = {
  trajanje_od: "",
  trajanje_do: "",
  naziv: "",
  lokacija: "",
  emailText: "",
  lat: null,
  lng: null,
  verifikatori: [],
};

const isEmptyCoordinate = (value) =>
  value === null || value === undefined || value === "";

export const useEventData = ({ editing, object, navigate }) => {
  const [eventObject, setEventObject] = useState(() => {
    return editing && object
      ? { ...object, oldObject: { ...object } }
      : { ...defaultEvent };
  });

  const [verifiers, setVerifiers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const { showAlert } = useAlert();
  const { t } = useContext(TranslationsContext);

  const setInputValue = (key, value) => {
    setEventObject((prev) => ({ ...prev, [key]: value }));
  };

  const validateAllFields = () => {
    const fieldsToValidate = [
      "trajanje_od",
      "trajanje_do",
      "prijava_od",
      "prijava_do",
      "naziv",
      "lokacija",
      "lat",
      "lng",
    ];
    let hasError = false;

    fieldsToValidate.forEach((field) => {
      const value = eventObject[field];
      let err = false;

      if (field === "lat" || field === "lng") {
        // Coordinates are optional — only validate format when a value was actually entered.
        err = isEmptyCoordinate(value) ? false : validateString(value, field);
      } else {
        err = !value;
      }

      if (err) {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: true }));
        hasError = true;
      }
    });

    return !hasError;
  };

  const fetchVerifiers = useCallback(async () => {
    try {
      setIsLoading(true);

      const result = await fetchData(
        apiRoutes.getVerifiers,
        showAlert,
        navigate,
        t
      );

      if (!result) return;

      setVerifiers(result.data);
    } catch (err) {
      console.error("Error fetching verifiers:", err);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, showAlert, t]);

  const loadGroupDataIfEditing = useCallback(async () => {
    if (!editing) return;
  }, [editing, object]);

  useEffect(() => {
    fetchVerifiers();
    loadGroupDataIfEditing();
  }, [fetchVerifiers, loadGroupDataIfEditing]);

  return {
    eventObject,
    setEventObject,
    setInputValue,
    isLoading,
    setIsLoading,
    verifiers,
    errors,
    setErrors,
    validateAllFields,
  };
};
